import { render, staticRenderFns } from "./RoleDetails.vue?vue&type=template&id=0fa298e1&scoped=true"
import script from "./RoleDetails.vue?vue&type=script&lang=js"
export * from "./RoleDetails.vue?vue&type=script&lang=js"
import style0 from "./RoleDetails.vue?vue&type=style&index=0&id=0fa298e1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa298e1",
  null
  
)

export default component.exports